import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import { CheckSquare, GitMerge, Send, Users } from 'react-feather';

/**
 * Advanced Spotlight Hover Card Component.
 * Tracks mouse position to create a radial gradient 'glow' effect underneath the cursor.
 */
function SpotlightCard({ children, className }) {
  const divRef = useRef(null);

  const handleMouseMove = (e) => {
    if (!divRef.current) return;
    const rect = divRef.current.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    divRef.current.style.setProperty('--mouse-x', `${x}px`);
    divRef.current.style.setProperty('--mouse-y', `${y}px`);
  };

  return (
    <div
      ref={divRef}
      onMouseMove={handleMouseMove}
      className={`ui-card spotlight-card ${className || ''}`}
    >
      {children}
    </div>
  );
}

/**
 * Landing hero section content.
 */
function HomeContent() {
  return (
    <main className="hero-section">
      {/* Ambient Grid Background Layer */}
      <div className="hero-background-grid" />
      <div className="hero-background-glow" />

      <div className="hero-content stagger-2">
        <h1>Level Up Your Skills, Boost Your Rank!</h1>
        <p className="secondary-text">
          Task-based mentorship for college students to learn, earn points, and climb the
          leaderboard.
        </p>
        <Link to="/login" className="cta-button">
          Start Your Journey
        </Link>
      </div>

      <SpotlightCard className="card-task stagger-3">
        <div className="card-header">
          <span className="card-title">Submit Task</span>
          <CheckSquare className="card-icon" size={20} />
        </div>
        <div className="card-body">
          <p>Complete the assigned task and submit for peer review.</p>
        </div>
        <div className="card-footer">
          <div className="avatar-group">
            <img
              src="https://randomuser.me/api/portraits/women/68.jpg"
              alt="Avatar"
              className="avatar"
            />
            <img
              src="https://randomuser.me/api/portraits/men/75.jpg"
              alt="Avatar"
              className="avatar"
            />
          </div>
        </div>
      </SpotlightCard>

      <SpotlightCard className="card-sticky-note stagger-4">
        <p className="sticky-note-text">"The only way to do great work is to love what you do."</p>
      </SpotlightCard>

      <SpotlightCard className="card-reminder stagger-4">
        <div className="card-header">
          <span className="card-title">Weekly Sync</span>
          <Send className="card-icon" size={20} />
        </div>
        <div className="reminder-item">
          <div className="reminder-checkbox" />
          <span className="reminder-text">Sync up with the team on project progress.</span>
        </div>
      </SpotlightCard>

      <SpotlightCard className="card-integration stagger-5">
        <div className="card-header">
          <span className="card-title">Connect</span>
        </div>
        <div className="integration-icons">
          <GitMerge className="card-icon" size={24} />
          <Users className="card-icon" size={24} />
        </div>
      </SpotlightCard>
    </main>
  );
}

export default HomeContent;

